var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ReferralApi } from "@jti/rest-api";
// async actions
export const fetchReferralStatus = createAsyncThunk("referral/status", () => __awaiter(void 0, void 0, void 0, function* () {
    return yield ReferralApi.init().getStatus();
}));
export const validateReferralCode = createAsyncThunk("referral/validateCode", (_a) => __awaiter(void 0, [_a], void 0, function* ({ targetValue, ciam_token }) {
    return yield ReferralApi.init().verifyCode(targetValue, ciam_token);
}));
export const initialState = {
    voucher: "",
    isOpen: false,
    isActive: false,
    isCodeValid: false,
    isLoaded: false,
};
// slice
export const referral = createSlice({
    name: "referral",
    initialState,
    reducers: {
        saveVoucher(state, action) {
            state.voucher = action.payload;
        },
        saveOpenStatus(state, action) {
            state.isOpen = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchReferralStatus.fulfilled, (state, action) => {
            state.isActive = action.payload;
            state.isLoaded = true;
        });
        builder.addCase(validateReferralCode.fulfilled, (state, action) => {
            state.isCodeValid = action.payload;
        });
    },
});
